export default __webpack_public_path__ + "static/media/logo.0a2d5ee3.png";